import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Calltoaction from "./sections/Calltoaction";
import Footer from "@/reusable_sections/Footer";
import BlogList from "./sections/BlogList";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogList />
      <Calltoaction />
      <Footer />
    </div>;
}